var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockboxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LockBox Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.160381 0 0 0 0 0.175645 0 0 0 0 0.218892 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LockBox-Logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/modules",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "Shield-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.0915696,0 C17.5787435,0 17.9736761,0.39982897 17.9736761,0.893043 L17.9736761,9.04057354 L17.977459,9.06741958 C18.0132312,9.34529934 18.241371,11.7408658 15.909302,14.404258 C14.4152484,16.1105756 12.3896798,17.6167907 9.83259615,18.9229033 C9.30555901,19.1921045 8.68366124,19.1923793 8.15639216,18.923644 C5.48388837,17.5615388 3.46367769,16.0550768 2.09576013,14.404258 C0.603581757,12.6034798 -0.0917748816,10.8331563 0.00969021567,9.09328751 L0.0130088157,9.04057354 L0.0130088157,0.893043 C0.0130088157,0.39982897 0.407941321,0 0.895115256,0 L17.0915696,0 Z M15.0251139,2.25 L9,2.25 C9.07828464,12 9.13676822,16.875 9.17545072,16.875 C11.2635739,16.875 12.8895313,14.4730099 14.081718,13.1117243 C15.9426031,10.9868927 15.7605579,9.07573032 15.7320133,8.85404022 L15.7320133,8.85404022 L15.7289947,8.83262268 L15.7289947,2.96246206 C15.7289947,2.56898013 15.4138565,2.25 15.0251139,2.25 L15.0251139,2.25 Z",
    id: "Shield",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#979797",
    strokeWidth: 0.75,
    fill: "#D8D8D8",
    cx: 9,
    cy: 6.75,
    r: 1.27025732
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M9.045,4.51505679 C9.66632034,4.51505679 10.2288203,4.76689662 10.6359903,5.17406653 C11.0431602,5.58123645 11.295,6.14373645 11.295,6.76505679 C11.295,7.34448596 11.0760136,7.87280346 10.7161976,8.27163031 L10.7161976,8.27163031 L11.3539767,12.7568545 L6.74557687,12.7568545 L7.31914982,8.24804784 C7.01037372,7.85664451 6.795,7.33572559 6.795,6.76505679 C6.795,6.14373645 7.04683983,5.58123645 7.45400974,5.17406653 C7.86117966,4.76689662 8.42367966,4.51505679 9.045,4.51505679 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    strokeWidth: 1.125,
    fill: "#000000",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockboxLogo);
export default __webpack_public_path__ + "static/media/lockbox_logo.b7c662b37c4f4178b1dab6bea976076f.svg";
export { ForwardRef as ReactComponent };